import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import { createVuetify } from 'vuetify'

const defaultTheme = {
  dark: false,
  colors: {
    primary: '#3B44F6', // '#3f51b5',
    secondary: '#CD3432', 
    surface: '#fff',   
    accent: '#7E8085',
    background: '#F5F6FA',
    disabled: '#D9D9D9'
  },
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'defaultTheme',
    themes: {
      defaultTheme
    }
  },
  display: {
    mobileBreakpoint: 'sm'
  },
  defaults: {
    VCard: {
      rounded: 'lg',
      elevation: 0,
      style: "border: 0.6px solid #D4D4D4;"
    },
    VTextField: {
      rounded: 'lg',
      variant: 'outlined'
    },
    VBtn: {
      rounded: 'lg',
      style: 'text-transform: none;'
    }
  }
})
